import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currency: [],
  currenciesSelection: [],
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    getCurrency: (state, action) => {
      state.currency = action.payload;
    },
    resetCurrency: state => {
      state.currency = initialState.currency;
    },
    resetCurrenciesSelection: (state, action) => {
      state.currenciesSelection = initialState.currenciesSelection;
    },
    setCurrenciesSelection: (state, action) => {
      state.currenciesSelection = action.payload;
    },
  },
});

export const { getCurrency, resetCurrency, resetCurrenciesSelection, setCurrenciesSelection } =
  currencySlice.actions;

export default currencySlice.reducer;
